import { Col, DesignTokens, Row } from "melco-ui";
import { useEffect, useState } from "react";
import { Search } from "../search/Search";
import { AllProductsGeneralSelect } from "../common/AllProductsGeneralSelect";
import { isEmpty } from "lodash-es";
import { CategoriesSelect } from "../common/CategoriesSelect";
import { MachinesSelect } from "../machines/MachinesSelect";
import styled from "styled-components";

export type ManageHoopsListFiltersType = {
    machines?: string | string[];
    searchText?: string;
    products?: string | string[];
    categories?: string | string[];
};


type ManageHoopsListFilterProps = {
    onFiltersChange: (filters: ManageHoopsListFiltersType | undefined) => void;
};


const { spacings } = DesignTokens;


const SelectWrapper = styled.div`
max-width: 300px;
min-width: 225px;
`

export const ManageHoopsFilter: React.FC<ManageHoopsListFilterProps> = ({
    onFiltersChange
}) => {

    const [manageHoopsFilter, setManageHoopsFilter] = useState<
        ManageHoopsListFiltersType | undefined
    >(undefined);

    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        onFiltersChange(manageHoopsFilter);
    }, [manageHoopsFilter, onFiltersChange])


    return (
        <Row gutter={[spacings.middle, spacings.middle]}>
            <Col flex={0}>
                <Search
                    onSearchInputChange={(value) => {
                        setManageHoopsFilter((prevFilter) => {
                            return { ...prevFilter, searchText: value };
                        });
                    }}
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                />
            </Col>
            <Col flex={0}>
                <SelectWrapper>
                    <AllProductsGeneralSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageHoopsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    products: !isEmpty(value) ? value : undefined,
                                };
                            });
                        }}
                        value={manageHoopsFilter?.products ?? undefined}
                    />
                </SelectWrapper>
            </Col>
            <Col flex={0}>
                <SelectWrapper>
                    <CategoriesSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageHoopsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    categories: !isEmpty(value) ? value : undefined
                                }
                            })
                        }}
                        value={manageHoopsFilter?.categories ?? undefined}
                    />
                </SelectWrapper>
            </Col>
            <Col flex={0}>
                <SelectWrapper>
                    <MachinesSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageHoopsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    machines: !isEmpty(value) ? value : undefined
                                }
                            })
                        }}
                        value={manageHoopsFilter?.machines ?? undefined}
                    />
                </SelectWrapper>
            </Col>
        </Row>
    )
}